import { useDocumentResolverContext } from '../contexts/DocumentResolverContext/hooks/useDocumentResolverContext.hook';
import type {
  ResolverParameters,
  ResolverResult,
} from '../types/resolvers.type';

export const useDocIdentifiant = ({
  enabled,
}: Readonly<ResolverParameters>): ResolverResult<string> => {
  const { printerSettings } = useDocumentResolverContext();

  if (!enabled) {
    return {
      data: undefined,
      error: null,
      isLoading: false,
      isSuccess: false,
    };
  }

  return {
    data: { generated: printerSettings?.code ?? 'Aucun identifiant spécifié' },
    error: null,
    isSuccess: true,
    isLoading: false,
  };
};
